import type { VehicleFilter } from '../api/generated';

/**
 * Formats a vehicle filter into a display label following priority rules:
 * 1. If both manufacturer and modelSeries exist: "[Manufacturer ModelSeries]"
 * 2. Otherwise, first available in order: modelSeries, manufacturer, engineBaseType, euroCode, modelYear range
 */
export const formatFilterLabel = (filter: VehicleFilter): string => {
  // Priority 1: Both manufacturer and model series
  if (filter.manufacturer && filter.modelSeries) {
    return `${filter.manufacturer} ${filter.modelSeries}`;
  }

  // Priority 2: Model series only
  if (filter.modelSeries) {
    return filter.modelSeries;
  }

  // Priority 3: Manufacturer only
  if (filter.manufacturer) {
    return filter.manufacturer;
  }

  // Priority 4: Engine type
  if (filter.engineBaseType) {
    return filter.engineBaseType;
  }

  // Priority 5: Euro code
  if (filter.euroCode) {
    return filter.euroCode;
  }

  // Priority 6: Model year range
  if (filter.modelYearMin || filter.modelYearMax) {
    if (filter.modelYearMin && filter.modelYearMax) {
      return `${filter.modelYearMin}-${filter.modelYearMax}`;
    }
    if (filter.modelYearMin) {
      return `${filter.modelYearMin}+`;
    }
    if (filter.modelYearMax) {
      return `≤${filter.modelYearMax}`;
    }
  }

  return 'Filter';
};
